import styles from './RatingRange.module.css';
import { JSX, ReactNode } from 'react';
import { cx } from '@libs/classnames';

export type RatingRangeProps = {
  from: ReactNode;
  to?: ReactNode;
  className?: string;
};

export function RatingRange({
  from,
  to,
  className,
}: RatingRangeProps): JSX.Element {
  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.item}>{from}</div>
      {to && <div className={styles.item}>{to}</div>}
    </div>
  );
}
